import { useContext } from 'react'

import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiDeleteFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  DeleteWidgetResponse,
  DeleteWidgetVars,
  GetWidgetResponse,
  GetWidgetVars,
  ListWidgetsResponse,
  ListWidgetsVars,
  UpdateWidgetResponse,
  UpdateWidgetVars,
  WidgetApiPath
} from '@/common/api/params/widget'
import { ApiPath } from '@/common/api/path'
import { ApiCallBack } from '@/common/api/props'
import { useShowDeletedToast, useShowSavedToast } from '@/common/app/toast'
import { Widget } from '@/common/model/recommend/widget'

import { DeleteDialogContext } from '@/components/container/modal/dialog/delete/DeleteDialogProvider'

export const useWidgetGetApi = ({
  siteId,
  widgetId
}: {
  siteId: number
  widgetId?: number | null
}) => {
  // widgetId 未指定（複製でない等）の場合はフェッチしない
  return useSWR<GetWidgetResponse, Response, [string, GetWidgetVars] | null>(
    widgetId ? [WidgetApiPath.GET_WIDGET, { site_id: siteId, widget_id: widgetId }] : null
  )
}

export const useWidgetListApi = (vars: ListWidgetsVars) => {
  return useSWR<ListWidgetsResponse, Response, [string, ListWidgetsVars]>([
    WidgetApiPath.LIST_WIDGETS,
    vars
  ])
}

export const useWidgetDeleteApi = (widget: Widget, onSuccess: () => void) => {
  const showDeleted = useShowDeletedToast()
  const { showModal, hide } = useContext(DeleteDialogContext)

  const { trigger } = useCallMutation<DeleteWidgetResponse, DeleteWidgetVars>(
    WidgetApiPath.DELETE_WIDGET,
    {
      onSuccess: () => {
        showDeleted(widget.name)
        hide()
        onSuccess()
      }
    },
    apiDeleteFetcher
  )

  const onClickDelete = () => {
    showModal({
      name: widget.name,
      onClickDelete: () => trigger({ site_id: widget.site_id, widget_id: widget.id }).then()
    })
  }
  return { onClickDelete }
}

// 一覧カードのステータス変更など、部分更新に使う
export const useCallUpdateWidget = (callback?: ApiCallBack<UpdateWidgetResponse>) => {
  const showSaved = useShowSavedToast({ editing: true })
  return useCallMutation<UpdateWidgetResponse, UpdateWidgetVars>(
    ApiPath.UPDATE_WIDGET,
    {
      ...callback,
      onSuccess: (data) => {
        callback?.onSuccess && callback.onSuccess(data)
        showSaved('レコメンドパーツ')
      }
    },
    apiPutFetcher
  )
}
